module.exports = R;


//////////////////
// WEBPACK FOOTER
// external "R"
// module id = 27
// module chunks = 0